<template>
	<div>
		<div @keyup.enter="getRecordList" style="margin: 15px 0;">
			<el-row >
				<el-col :span="8" :offset="16">
					<el-input v-model="search" placeholder="请输入搜索条件">
						<el-button slot="append" icon="el-icon-search" @click="getRecordList"></el-button>
					</el-input>
				</el-col>
			</el-row>
			
		</div>
		<el-table
			:data="recordList"
			style="width: 100%;margin-bottom: 20px;"
			row-key="id"
			border
			:stripe="true"
			:default-sort="{ prop: 'operate_time', order: 'descending' }"
			@sort-change="sortChange"
		>
			<el-table-column prop="id" label="日志ID" width="80"></el-table-column>
			<el-table-column prop="admin_name_text" label="操作人"></el-table-column>
			<el-table-column prop="ip" label="操作IP"></el-table-column>
			<el-table-column prop="record" label="操作记录"></el-table-column>
			<el-table-column prop="operate_time" label="操作时间" sortable></el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="thispage"
				:page-sizes="pageSizes"
				:page-size="pagesize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</div>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
	name: '',
	data() {
		return {
			recordList: [],
			groupList: [],
			loading: false,
			thispage: 1,
			total: 0,
			pagesize: 10, //每页显示条数
			pageSizes: [10, 20, 30] ,//每页显示个数选择器
			sort_param:'operate_time',//排序字段
			sort_type:'desc',//排序方式ascending = asc;descending = desc,'' = asc;
			search:''
		};
	},
	mounted() {
		this.getRecordList();
	},
	methods: {
		...mapActions({
			exit: 'auth/logout'
		}),
		getRecordList() {
			this.$axios({
				url: this.HOST + '/admin.setting/recordList',
				method: 'post',
				data: {
					thispage: this.thispage,
					pagesize: this.pagesize,
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					sort_param:this.sort_param,
					sort_type:this.sort_type,
					search:this.search
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.total = res.data.total;
						this.recordList = res.data.data;
						if (this.thispage == 1) {
							this.groupList = res.data.groupList;
						}
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending'?'desc':'asc';
			this.getRecordList()
		},
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getRecordList();
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getRecordList();
		},
	}
};
</script>
<style>
.el-tree-node.is-expanded > .el-tree-node__children {
	display: flex;
	flex-flow: row wrap;
}
.el-tree::-webkit-scrollbar {
	display: none; /* Chrome Safari */
}
</style>
